import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      listaComercios: [],
      form: {
        fecha: this.currentdate(),
        motivo: '',
        cuit_proveedor: '',
        importe: '',
        razon_social: '',
        comercio: ''
      }

    };
  },

  mounted: function () {

    $('.box').boxWidget();
    this.getComercios();


  },

  computed: {

  },

  methods: {


    reload() {

      this.form = {
        fecha: this.currentdate(),
        motivo: '',
        cuit_proveedor: '',
        importe: '',
        razon_social: '',
        comercio: 0
      }
    },

    valida_data() {
      return (
        this.form.fecha != '' &&
        this.form.motivo != '' &&
        this.form.importe != '' &&
        this.form.razon_social != '' &&
        this.form.comercio != 0
      )

    },
    guardar(event) {
      event.preventDefault() 

      if (this.valida_data()) {
        this.loading = true
        this.$http
          .post(
            '/billetera/transferencia/proveedores',
            this.form)
          .then(() => {
            alert("Registro cargado.")
            this.loading = false
            this.reload()
          }).catch(() => {
            alert("Error al registrar")
            this.loading = false
          })
      } else {
        this.showNotification({
          msj: 'Virifique todos los campos cargados',
          bg: 'bg-red'
        })
      }
    },

    getComercios() {
      this.loading = true
      this.$http
        .get(
          '/billetera/transferencia/comercios',
          this.form
        )
        .then((r) => {
          this.listaComercios = r.data;
          this.loading = false;
        })

    },
  }
};



// WEBPACK FOOTER //
// ./src/components/configs/cargaTransferencias/tventas/index.js